export enum RootTypeEnum{

    Local="L",
    OutOfStation="O/S"
}